import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { IGCUserEntity } from '@apply/api/src/api/DrawApi';

interface AuthenticationStore {
    selectedEntity: IGCUserEntity | null;
    set_selectedEntity: (entity: IGCUserEntity | null) => void;
    reset: () => void;
}

export const useAuthenticationStore = create<AuthenticationStore>()(
    persist(
        (set) => ({
            selectedEntity: null,
            set_selectedEntity: (entity) => set({ selectedEntity: entity }),
            reset: () => set({ selectedEntity: null }),
        }),
        {
            name: 'authorizedDrawUser-selected-entity-persist',
            storage: createJSONStorage(() => sessionStorage),
        }
    )
);
